module.exports = __webpack_public_path__ + "static/media/internal_audit.f7d5bb6d.png";